import {useQuery} from "@tanstack/react-query";
import {getNewestGamesService} from "./games.service";
import type {Game} from "./games.types";

export const GAMES_QUERY_KEY = "games";

export interface UseGamesOptions {
  provider?: string;
}

export interface UseGamesResult {
  games: Game[];
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useGames = (options: UseGamesOptions = {}): UseGamesResult => {
  const query = useQuery<Game[], Error>({
    queryKey: [GAMES_QUERY_KEY, "newest", options.provider ?? "all"],
    queryFn: () => getNewestGamesService({provider: options.provider}),
    staleTime: 5 * 60_000,
  });

  return {
    games: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
